var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-heading"},[_vm._t("title",null,{"activeItem":_vm.activeItem}),_c('card-navigation',{attrs:{"items":_vm.items,"active-item":_vm.activeItem}}),_vm._t("body",null,{"activeItem":_vm.activeItem})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }